import { render, staticRenderFns } from "./PersonalDataSection.vue?vue&type=template&id=13e4946c&scoped=true&"
import script from "./PersonalDataSection.vue?vue&type=script&lang=js&"
export * from "./PersonalDataSection.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDataSection.vue?vue&type=style&index=0&id=13e4946c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e4946c",
  null
  
)

export default component.exports